// Carry Roll sidebar navigation items — top-level groups rendered by calc-sidebar's
// SidebarNav. The app has 7 top-level screens, which exceeds calc-nav's 5-item
// tab cap, so a vertical sidebar holds them (see calc-sidebar/INTEGRATION.md).
// Each item's content stays mounted (hidden via the `hidden` attribute) so
// component state survives navigation (UX Invariant #8).

import {
  Calculator,
  GitCompare,
  Flag,
  History,
  Activity,
  Target,
  Settings as SettingsIcon,
} from 'lucide-react';
import type { SidebarItemDef } from 'calc-sidebar';
import CalculatorScreen from '../../screens/CalculatorScreen';
import CompareScreen from '../../screens/CompareScreen';
import BagScreen from '../../screens/BagScreen';
import SessionsScreen from '../../screens/SessionsScreen';
import DiagnosticsScreen from '../../screens/DiagnosticsScreen';
import OptimizeScreen from '../../screens/OptimizeScreen';
import SettingsScreen from '../../screens/SettingsScreen';
import { ErrorBoundary } from './ErrorBoundary';

export const NAV_ITEMS: SidebarItemDef[] = [
  { id: 'calc', label: 'Calc', icon: <Calculator size={16} />, content: <ErrorBoundary panel="Calculator"><CalculatorScreen /></ErrorBoundary> },
  { id: 'compare', label: 'Compare', icon: <GitCompare size={16} />, content: <ErrorBoundary panel="Compare"><CompareScreen /></ErrorBoundary> },
  { id: 'bag', label: 'Bag', icon: <Flag size={16} />, content: <ErrorBoundary panel="Bag"><BagScreen /></ErrorBoundary> },
  { id: 'sessions', label: 'Sessions', icon: <History size={16} />, content: <ErrorBoundary panel="Sessions"><SessionsScreen /></ErrorBoundary> },
  { id: 'diagnostics', label: 'Diagnostics', icon: <Activity size={16} />, content: <ErrorBoundary panel="Diagnostics"><DiagnosticsScreen /></ErrorBoundary> },
  { id: 'optimize', label: 'Optimize', icon: <Target size={16} />, content: <ErrorBoundary panel="Optimize"><OptimizeScreen /></ErrorBoundary> },
  { id: 'settings', label: 'Settings', icon: <SettingsIcon size={16} />, content: <ErrorBoundary panel="Settings"><SettingsScreen /></ErrorBoundary> },
];
